import {
  DashboardOverview,
  DashboardOverviewFilter,
  QueryUser,
} from '../../../services/types/Dashboard';
import { ApiState, Action } from '../../../types';
import { serviceReducer, callService } from '../../../shared/hooks/serviceReducer';

export type OverviewAction =
  | Action<DashboardOverview, DashboardOverviewFilter>
  | {
      type: 'QUERY_USER';
      value: QueryUser;
    };

const reducer = (
  state: ApiState<DashboardOverview, DashboardOverviewFilter>,
  action: OverviewAction
): ApiState<DashboardOverview, DashboardOverviewFilter> => {
  switch (action.type) {
    case 'QUERY_USER': {
      const filter = { ...state.filter, queryUser: action.value };
      return callService(state, filter);
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
